import React from 'react';
import PropTypes from 'prop-types';

const Spinner = ({ color = '#000', size = 10 }) => {
  const childStyle = {
    width: `${size}px`,
    height: `${size}px`,
    margin: `${3 * size}px ${0.2 * size}px`,
    backgroundColor: color,
    borderRadius: '50%',
    animation: `bouncingAnimation 0.6s alternate infinite`,
  };

  return (
    <div className="flex justify-center">
      <div style={{ ...childStyle }} />
      <div style={{ ...childStyle, animationDelay: '0.2s' }} />
      <div style={{ ...childStyle, animationDelay: '0.4s' }} />
      <style>
        {`
          @keyframes bouncingAnimation {
            0% {
              opacity: 1;
              transform: translateY(0);
            }
            100% {
              opacity: 0.1;
              transform: translateY(-${size}px);
            }
          }
        `}
      </style>
    </div>
  );
};

Spinner.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

export default Spinner;
